import { render } from "./customers-companies.vue?vue&type=template&id=4ab6c2d4"
import script from "./customers-companies.vue?vue&type=script&lang=js"
export * from "./customers-companies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__